import React, { FC, useEffect } from "react";
import { default as OrganizationAddEditBaseView } from './base'
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router";
import {
  Box,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { observer } from "mobx-react"
import store from "./store"
import CustomButton from 'components/Button';
import MtmTabs from "./mtmTabs";


type OrganizationProps = {};

const OrganizationAddEditView: FC<OrganizationProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const query = useQuery();
  const id = query.get("id")

  useEffect(() => {
    if ((id != null) &&
      (id !== '') &&
      !isNaN(Number(id.toString()))) {
      store.doLoad(Number(id))
    } else {
      // New organization - id = 0
      store.clearStore()
    }
    return () => {
      store.clearStore()
    }
  }, [])

  return (
    <OrganizationAddEditBaseView {...props}>

      {/* start MTM */}
      <div style={{marginTop: 20}}></div> 
      {store.id > 0 && <Grid item xs={12} spacing={0}><MtmTabs /></Grid>}
      {/* end MTM */}
      
      <Box display="flex" p={2}>
        <Box m={2}>
          <CustomButton
            variant="contained"
            id="id_OrganizationSaveButton"
            onClick={() => {
              store.onSaveClick((id: number) => {
                if (store.id === 0) {
                  store.doLoad(id)
                  navigate(`/user/Organization/addedit?id=${id}`)
                }
              })
            }}
          >
            {translate("common:save")}
          </CustomButton>
        </Box>
        <Box m={2}>
          <CustomButton
            color={"secondary"}
            sx={{color:"white", backgroundColor: "red !important"}}
            variant="contained"
            id="id_OrganizationCancelButton"
            onClick={() => navigate('/user/Organization')}
          >
            {translate("common:goOut")}
          </CustomButton>
        </Box>
      </Box>
    </OrganizationAddEditBaseView>
  );
})

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default OrganizationAddEditView
